import createFormSlice from '@/store/reducers/createFormSlice';
import { createSlice } from '@reduxjs/toolkit';
import { sendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '../../api/apiConfig';
import { ReportFormTypes } from '@/store/types/ReportFormTypes';
import { getTranslation } from '@/core/utils/i18nHelper';

const reportFormData: ReportFormTypes = {
	email: '',
	type: getTranslation('report.type_options')[0],
	question_id: null,
	comment: '',
};

const formSlice = createFormSlice('reportForm', reportFormData);

const combinedSlice = createSlice({
	name: 'reportForm',
	initialState: formSlice.getInitialState(),
	reducers: {
		...formSlice.caseReducers,
	},
});

export const {
	resetSuccessMessage,
	setError,

} = combinedSlice.actions;

export const sendReport = (data: ReportFormTypes) => sendForm(combinedSlice, API_ENDPOINTS.reportForm, 'validation.success_message')(data);

export default combinedSlice.reducer;
export { combinedSlice as reportFormSlice };
